import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function CollaboraPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToContact = () => {
    const contactForm = document.getElementById('contact-form-collabora');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8 mx-auto">
              <Link to="/" className="text-sm font-medium text-gray-700 hover:text-teal-500 transition-colors whitespace-nowrap">Home</Link>
              <Link to="/#problema" className="text-sm font-medium text-gray-700 hover:text-teal-500 transition-colors whitespace-nowrap">Il Problema</Link>
              <Link to="/#soluzione" className="text-sm font-medium text-gray-700 hover:text-teal-500 transition-colors whitespace-nowrap">Soluzione</Link>
              <Link to="/#metodo" className="text-sm font-medium text-gray-700 hover:text-teal-500 transition-colors whitespace-nowrap">Metodo E-LUME</Link>
              <Link to="/#servizi" className="text-sm font-medium text-gray-700 hover:text-teal-500 transition-colors whitespace-nowrap">Servizi</Link>
              <Link to="/collabora" className="text-sm font-medium text-teal-500 transition-colors whitespace-nowrap">Collabora</Link>
              <Link to="/#contatti" className="bg-teal-500 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-teal-600 transition-colors whitespace-nowrap">Contattaci</Link>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden">
              <i className={`ri-menu-line text-2xl text-gray-900`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 space-y-3">
              <Link to="/" className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-500 py-2 whitespace-nowrap">Home</Link>
              <Link to="/#problema" className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-500 py-2 whitespace-nowrap">Il Problema</Link>
              <Link to="/#soluzione" className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-500 py-2 whitespace-nowrap">Soluzione</Link>
              <Link to="/#metodo" className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-500 py-2 whitespace-nowrap">Metodo E-LUME</Link>
              <Link to="/#servizi" className="block w-full text-left text-sm font-medium text-gray-700 hover:text-teal-500 py-2 whitespace-nowrap">Servizi</Link>
              <Link to="/collabora" className="block w-full text-left text-sm font-medium text-teal-500 py-2 whitespace-nowrap">Collabora</Link>
              <Link to="/#contatti" className="block w-full text-left bg-teal-500 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-teal-600 transition-colors whitespace-nowrap">Contattaci</Link>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-24 overflow-hidden bg-gradient-to-br from-teal-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 mb-4">
              <div className="w-2 h-2 bg-black rounded-full"></div>
              <span className="text-sm font-bold uppercase tracking-wider text-gray-600">OPPORTUNITÀ</span>
            </div>
            <h1 className="text-6xl md:text-7xl font-extrabold text-gray-900 mb-6 leading-tight">
              Collabora con <span className="text-teal-500">Energy Maker</span>
            </h1>
            <p className="text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Unisciti a noi per portare chiarezza e sostenibilità nel mondo dell'energia
            </p>
          </div>
        </div>
      </section>

      {/* Collaboration Categories */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-10">
            {/* Affiliato */}
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-3xl p-12 hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="w-20 h-20 bg-teal-500 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <i className="ri-building-4-line text-4xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Affiliato</h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                Sei un professionista o un'attività che vuole offrire valore aggiunto ai propri clienti? Diventa nostro partner affiliato.
              </p>
              
              <div className="space-y-4 mb-8">
                <h3 className="text-xl font-bold text-gray-900">Chi può diventare Affiliato:</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700"><strong>Studi professionali</strong> (commercialisti, consulenti, avvocati)</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700"><strong>Amministratori di condominio</strong></span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700"><strong>Negozi fisici</strong> e attività commerciali</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700"><strong>Agenzie immobiliari</strong></span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-2xl p-6 mb-8">
                <h4 className="font-bold text-gray-900 mb-3">Vantaggi:</h4>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-center">
                    <i className="ri-star-fill text-yellow-500 mr-2"></i>
                    Commissioni competitive
                  </li>
                  <li className="flex items-center">
                    <i className="ri-star-fill text-yellow-500 mr-2"></i>
                    Materiale marketing dedicato
                  </li>
                  <li className="flex items-center">
                    <i className="ri-star-fill text-yellow-500 mr-2"></i>
                    Supporto tecnico costante
                  </li>
                  <li className="flex items-center">
                    <i className="ri-star-fill text-yellow-500 mr-2"></i>
                    Formazione sul Metodo E-LUME
                  </li>
                </ul>
              </div>

              <button onClick={scrollToContact} className="w-full bg-teal-500 text-white px-8 py-4 rounded-2xl text-base font-bold hover:bg-teal-600 transition-colors whitespace-nowrap shadow-lg">
                Diventa Affiliato
              </button>
            </div>

            {/* Ambasciatore */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-3xl p-12 hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="w-20 h-20 bg-blue-500 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <i className="ri-user-heart-line text-4xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Ambasciatore</h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                Sei soddisfatto dei nostri servizi? Aiutaci a crescere segnalando Energy Maker ai tuoi amici e conoscenti.
              </p>
              
              <div className="space-y-4 mb-8">
                <h3 className="text-xl font-bold text-gray-900">Chi può diventare Ambasciatore:</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <i className="ri-check-line text-blue-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700"><strong>Clienti soddisfatti</strong> che vogliono condividere la loro esperienza</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-blue-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700"><strong>Privati e famiglie</strong> che credono nella sostenibilità</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-blue-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700"><strong>Imprenditori</strong> che vogliono aiutare altri imprenditori</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-2xl p-6 mb-8">
                <h4 className="font-bold text-gray-900 mb-3">Vantaggi:</h4>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-center">
                    <i className="ri-gift-fill text-blue-500 mr-2"></i>
                    Bonus per ogni segnalazione
                  </li>
                  <li className="flex items-center">
                    <i className="ri-gift-fill text-blue-500 mr-2"></i>
                    Sconti sui servizi futuri
                  </li>
                  <li className="flex items-center">
                    <i className="ri-gift-fill text-blue-500 mr-2"></i>
                    Accesso anticipato a nuovi servizi
                  </li>
                  <li className="flex items-center">
                    <i className="ri-gift-fill text-blue-500 mr-2"></i>
                    Riconoscimenti speciali
                  </li>
                </ul>
              </div>

              <button onClick={scrollToContact} className="w-full bg-blue-500 text-white px-8 py-4 rounded-2xl text-base font-bold hover:bg-blue-600 transition-colors whitespace-nowrap shadow-lg">
                Diventa Ambasciatore
              </button>
            </div>

            {/* Promotore */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-3xl p-12 hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="w-20 h-20 bg-green-500 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <i className="ri-team-line text-4xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Promotore</h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                Vuoi lavorare attivamente con noi? Diventa un promotore Energy Maker e costruisci il tuo business nel settore energetico.
              </p>
              
              <div className="space-y-4 mb-8">
                <h3 className="text-xl font-bold text-gray-900">Chi può diventare Promotore:</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <i className="ri-check-line text-green-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700"><strong>Agenti occasionali</strong> che vogliono un'attività flessibile</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-green-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700"><strong>Agenti professionali</strong> con esperienza nel settore</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-green-500 text-xl mr-3 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700"><strong>Venditori</strong> che cercano un progetto serio e trasparente</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-2xl p-6 mb-8">
                <h4 className="font-bold text-gray-900 mb-3">Vantaggi:</h4>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-center">
                    <i className="ri-money-euro-circle-fill text-green-500 mr-2"></i>
                    Provvigioni elevate e ricorrenti
                  </li>
                  <li className="flex items-center">
                    <i className="ri-money-euro-circle-fill text-green-500 mr-2"></i>
                    Formazione completa sul Metodo E-LUME
                  </li>
                  <li className="flex items-center">
                    <i className="ri-money-euro-circle-fill text-green-500 mr-2"></i>
                    Strumenti professionali di vendita
                  </li>
                  <li className="flex items-center">
                    <i className="ri-money-euro-circle-fill text-green-500 mr-2"></i>
                    Supporto commerciale dedicato
                  </li>
                </ul>
              </div>

              <button onClick={scrollToContact} className="w-full bg-green-500 text-white px-8 py-4 rounded-2xl text-base font-bold hover:bg-green-600 transition-colors whitespace-nowrap shadow-lg">
                Diventa Promotore
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Why Collaborate Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-6">Perché collaborare con Energy Maker?</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Unisciti a un progetto innovativo che sta cambiando il modo di vivere l'energia
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Metodo Unico</h3>
              <p className="text-gray-600">Il Metodo E-LUME è un approccio innovativo e strutturato</p>
            </div>

            <div className="bg-white rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Trasparenza Totale</h3>
              <p className="text-gray-600">Lavoriamo con onestà e chiarezza in ogni fase</p>
            </div>

            <div className="bg-white rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Crescita Garantita</h3>
              <p className="text-gray-600">Un mercato in espansione con opportunità concrete</p>
            </div>

            <div className="bg-white rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-2-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Supporto Continuo</h3>
              <p className="text-gray-600">Ti affianchiamo in ogni momento del percorso</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-teal-500 via-teal-600 to-blue-600"></div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-5xl md:text-6xl font-extrabold text-white mb-6">
            AGISCI ADESSO E CAMBIA IL FUTURO
          </h2>
          <p className="text-2xl text-white/90 mb-12 leading-relaxed">
            Compila il form di contatto e ti ricontatteremo per discutere insieme le opportunità
          </p>
          
          <button onClick={scrollToContact} className="bg-white text-teal-700 px-12 py-5 rounded-2xl text-lg font-bold hover:bg-gray-100 transition-all shadow-2xl hover:scale-105 whitespace-nowrap">
            Contattaci Ora
          </button>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact-form-collabora" className="py-24 bg-white">
        <div className="max-w-3xl mx-auto px-6">
          <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-3xl p-10 shadow-2xl">
            <h3 className="text-3xl font-bold text-gray-900 mb-2">Richiedi informazioni sulla collaborazione</h3>
            <p className="text-gray-600 mb-8">Compila il form e ti ricontatteremo al più presto</p>
            
            <div className="w-full" style={{ minHeight: '492px' }}>
              <iframe
                src="https://link.delera.co/widget/form/lCDQTdKOE4mMKgKIuSYT"
                style={{ width: '100%', height: '100%', minHeight: '492px', border: 'none', borderRadius: '3px' }}
                id="inline-lCDQTdKOE4mMKgKIuSYT-collabora" 
                data-layout="{'id':'INLINE'}"
                data-trigger-type="alwaysShow"
                data-trigger-value=""
                data-activation-type="alwaysActivated"
                data-activation-value=""
                data-deactivation-type="neverDeactivate"
                data-deactivation-value=""
                data-form-name="Form E-lume.org"
                data-height="492"
                data-layout-iframe-id="inline-lCDQTdKOE4mMKgKIuSYT-collabora"
                data-form-id="lCDQTdKOE4mMKgKIuSYT"
                title="Form E-lume.org"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <img src="https://static.readdy.ai/image/4153abc494094421aaf0d0211ae45ade/b65f5728d87d835b00ff4aad46a33f84.png" alt="Energy Maker" className="h-10 w-auto" />
                <div className="font-bold text-xl">ENERGY MAKER</div>
              </div>
              <p className="text-gray-400 text-sm mb-6">Soluzioni intelligenti per l'energia e la sostenibilità</p>
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 border-2 border-gray-600 rounded-full flex items-center justify-center hover:border-teal-400 transition-colors">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border-2 border-gray-600 rounded-full flex items-center justify-center hover:border-teal-400 transition-colors">
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border-2 border-gray-600 rounded-full flex items-center justify-center hover:border-teal-400 transition-colors">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-4">Servizi</h4>
              <ul className="space-y-3">
                <li><Link to="/#servizi" className="text-gray-300 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Bolletta Sotto Controllo</Link></li>
                <li><Link to="/#servizi" className="text-gray-300 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Efficienza energetica</Link></li>
                <li><Link to="/#servizi" className="text-gray-300 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Condomini</Link></li>
                <li><Link to="/#servizi" className="text-gray-300 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Formazione & Academy</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-4">Azienda</h4>
              <ul className="space-y-3">
                <li><Link to="/#metodo" className="text-gray-300 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Metodo E-LUME</Link></li>
                <li><Link to="/#soluzione" className="text-gray-300 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Chi siamo</Link></li>
                <li><Link to="/collabora" className="text-gray-300 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Collabora con noi</Link></li>
                <li><Link to="/#contatti" className="text-gray-300 hover:text-teal-400 transition-colors text-sm whitespace-nowrap">Contatti</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-4">Contatti</h4>
              <ul className="space-y-3 text-sm text-gray-300">
                <li className="flex items-start">
                  <i className="ri-mail-line mr-2 mt-1"></i>
                  <span>info@e-lume.com</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-phone-line mr-2 mt-1"></i>
                  <span>+39 388 141 5515</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-line mr-2 mt-1"></i>
                  <span>Italia</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2025 Energy Maker. Tutti i diritti riservati.
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-teal-400 transition-colors whitespace-nowrap">Privacy Policy</a>
              <a href="#" className="hover:text-teal-400 transition-colors whitespace-nowrap">Cookie Policy</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors whitespace-nowrap">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
